export const HIGHLIGHT_STEPS = [
  {
    title: "Find Your Cards",
    text: "Look for unwanted gift cards and store credits, new or partially used."
  },
  {
    title: "List For Sale",
    text: "It's free to list cards for thousands of brands, and you set the selling price."
  },
  {
    title: "Get Paid",
    text: "Receive funds via Direct Deposit or PayPal when you sell."
  }
];
